import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import Modal from "react-modal";
import PaginatedTable from "../../components-bootstrap/PaginatedTable";
import { BodyBuilder } from "../../../exports/Images";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import {
  converSlot,
  convertStraight,
  convertThenFormat,
  formatDateTimezon,
} from "../../common-data/Converts";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import PayoutsTable from "../../components-bootstrap/PayoutsTable";

const AsssignedMembersTab = ({
  setSelectdKey,
  allAssignedMembersData,
  setAllAssignedMembersData,
  loading,
}) => {
  const onClickTab = (selectedKey) => {
    setSelectdKey(selectedKey);
  };
  const iniModValues = {
    isModOpen: false,
    cardType: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const closeModalValues = () => {
    setModValues(iniModValues);
  };

  const tbColumns = [
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth150">{row?.gym_name || "N/A"}</p>
        </div>
      ),
    },
    {
      dataField: "member_name",
      text: "Member Name/Profile",
      formatter: (cell, row, rowIndex) => (
        <div className="emeberDetailsRowContainer">
          <img
            src={row?.member_profile || BodyBuilder}
            alt={row?.member_name || "N/A"}
            className="image"
          />
          <p
            className="name"
            style={{
              cursor: "pointer",
            }}
          >
            {row?.member_name || "N/A"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.member_mobile || ""}
              <br />
              {row?.member_email || ""}
            </small>
          </p>
        </div>
      ),
    },
    {
      dataField: "trainer_name",
      text: "trainer name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth100">{row?.trainer_name || "N/A"}</p>
        </div>
      ),
    },
    // {
    //   dataField: "plan_name",
    //   text: "Plan Name",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p
    //         className="info violetBg minWidth150"
    //         style={{
    //           background: "#E8E8FF",
    //           color: "#1E1E1E",
    //           borderRadius: "8px",
    //           padding: "5px 10px",
    //         }}
    //       >
    //         {row?.plan_name || "N/A"}
    //       </p>
    //     </div>
    //   ),
    // },
    // {
    //   dataField: "price",
    //   text: "Price",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info">₹{row?.price || "0"}</p>
    //     </div>
    //   ),
    // },
    // {
    //   dataField: "price",
    //   text: "Amount/(Online,Cash)",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info minWidth150 bold">
    //         {row?.is_partial === "true"
    //           ? `₹${convertThenFormat(
    //               row?.total_partial_price || 0
    //             )} / ${convertThenFormat(row?.price || 0)}`
    //           : `₹${convertThenFormat(row?.price || 0)}`}
    //         <br />
    //         <small style={{ fontWeight: "500" }}>
    //           (₹
    //           {convertThenFormat(
    //             row?.is_partial === "true"
    //               ? row?.partial_total_online
    //               : row?.total_online || 0
    //           )}{" "}
    //           /{" "}
    //           {convertThenFormat(
    //             row?.is_partial === "true"
    //               ? row?.partial_total_cash
    //               : row?.total_cash || 0
    //           )}
    //           )
    //           <br />
    //           {row?.plan_name || ""}
    //         </small>
    //       </p>
    //     </div>
    //   ),
    // },
    {
      dataField: "plan_name",
      text: "plan name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.plan_name || "NA"}</span>;
      },
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className={`info ${row?.is_partial === "true" ? "link" : ""}`}
            onClick={() =>
              row?.is_partial === "true"
                ? setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardType: "partial_details",
                    partialDetails: row?.payment_details || [],
                  }))
                : null
            }
          >
            {row?.is_partial === "true" ? "Partial" : "Full"}
          </p>
        </div>
      ),
    },
    {
      dataField: "price",
      text: "Total Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">₹{convertThenFormat(row?.price || 0)}</p>
        </div>
      ),
    },
    {
      dataField: "total_partial_price",
      text: "Partial Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            {row?.is_partial === "true"
              ? `₹${convertThenFormat(row?.total_partial_price || 0)}`
              : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "total_online",
      text: "Online Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            ₹
            {convertThenFormat(
              row?.is_partial === "true"
                ? row?.partial_total_online
                : row?.total_online || 0
            )}
          </p>
        </div>
      ),
    },
    {
      dataField: "total_cash",
      text: "Cash Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            ₹
            {convertThenFormat(
              row?.is_partial === "true"
                ? row?.partial_total_cash
                : row?.total_cash || 0
            )}
          </p>
        </div>
      ),
    },
    {
      dataField: "time_slot",
      text: "Slot",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth150">
            {row?.time_slot ? converSlot(row.time_slot) : "NA"}
          </p>
        </div>
      ),
    },
    // {
    //   dataField: "sessions_consumed",
    //   text: "Session",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info ">{row?.sessions_consumed || 0}</p>
    //     </div>
    //   ),
    // },
    // {
    //   dataField: "n_session",
    //   text: "No. Of Sessions",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p
    //         className="info"
    // style={{
    //   background: "#FFEDC0",
    //   color: "#171717",
    //   borderRadius: "8px",
    //   padding: "5px 10px",
    // }}
    //       >
    //         {row?.n_session || "N/A"}
    //       </p>
    //     </div>
    //   ),
    // },
    // {
    //   dataField: "age",
    //   text: "Age",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info ">{row?.age || "N/A"}</p>
    //     </div>
    //   ),
    // },
    // {
    //   dataField: "gender",
    //   text: "Gender",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info ">{row?.gender || "N/A"}</p>
    //     </div>
    //   ),
    // },
    {
      dataField: "plan_status",
      text: "Plan Status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background: "#FFEDC0",
              color: "#171717",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
            // style={{
            //   background: row?.status === "active" ? "#B4E7B9" : "#F6EFEF",
            //   color: row?.status === "active" ? "#0A701B" : "#F13434",
            //   borderRadius: "8px",
            //   padding: "5px 10px",
            // }}
          >
            {row?.plan_status || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "start_date",
      text: "Start Date",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth90">
            {row?.start_date ? formatDateTimezon(row.start_date) : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "expire_date",
      text: "Expire Date",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth90">
            {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "regular_subscription_status",
      text: "Regular Subscription status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background:
                row?.regular_subscription_status === "active"
                  ? "#B4E7B9"
                  : "#F6EFEF",
              color:
                row?.regular_subscription_status === "active"
                  ? "#0A701B"
                  : "#F13434",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.regular_subscription_status || "NA"}
          </p>
        </div>
      ),
    },
    {
      dataField: "status",
      text: "PT Subscription Status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background: row?.status === "active" ? "#B4E7B9" : "#F6EFEF",
              color: row?.status === "active" ? "#0A701B" : "#F13434",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.status || "N/A"}
          </p>
        </div>
      ),
    },
  ];

  const tbColumnsRegular = [
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth150">{row?.gym_name || "N/A"}</p>
        </div>
      ),
    },
    {
      dataField: "member_name",
      text: "Member Name/Profile",
      formatter: (cell, row, rowIndex) => (
        <div className="emeberDetailsRowContainer">
          <img
            src={row?.member_profile || BodyBuilder}
            alt={row?.member_name || "N/A"}
            className="image"
          />
          <p
            className="name"
            style={{
              cursor: "pointer",
            }}
          >
            {row?.member_name || "N/A"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.member_mobile || ""}
              <br />
              {row?.member_email || ""}
            </small>
          </p>
        </div>
      ),
    },
    // {
    //   dataField: "member_mobile",
    //   text: "member mobile",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info ">{row?.member_mobile || "N/A"}</p>
    //     </div>
    //   ),
    // },
    // {
    //   dataField: "member_email",
    //   text: "member email",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info" style={{ textTransform: "lowercase" }}>
    //         {row?.member_email || "N/A"}
    //       </p>
    //     </div>
    //   ),
    // },
    {
      dataField: "trainer_name",
      text: "trainer name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth100">{row?.trainer_name || "N/A"}</p>
        </div>
      ),
    },
    // {
    //   dataField: "price",
    //   text: "Amount/(Online,Cash)",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info minWidth150 bold">
    //         {row?.is_partial === "true"
    //           ? `₹${convertThenFormat(
    //               row?.total_partial_price || 0
    //             )} / ${convertThenFormat(row?.price || 0)}`
    //           : `₹${convertThenFormat(row?.price || 0)}`}
    //         <br />
    //         <small style={{ fontWeight: "500" }}>
    //           (₹
    //           {convertThenFormat(
    //             row?.is_partial === "true"
    //               ? row?.partial_total_online
    //               : row?.total_online || 0
    //           )}{" "}
    //           /{" "}
    //           {convertThenFormat(
    //             row?.is_partial === "true"
    //               ? row?.partial_total_cash
    //               : row?.total_cash || 0
    //           )}
    //           )
    //           <br />
    //           {row?.plan_name || ""}
    //         </small>
    //       </p>
    //     </div>
    //   ),
    // },
    {
      dataField: "plan_name",
      text: "plan name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.plan_name || "NA"}</span>;
      },
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className={`info ${row?.is_partial === "true" ? "link" : ""}`}
            onClick={() =>
              row?.is_partial === "true"
                ? setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardType: "partial_details",
                    partialDetails: row?.payment_details || [],
                  }))
                : null
            }
          >
            {row?.is_partial === "true" ? "Partial" : "Full"}
          </p>
        </div>
      ),
    },
    {
      dataField: "price",
      text: "Total Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">₹{convertThenFormat(row?.price || 0)}</p>
        </div>
      ),
    },
    {
      dataField: "total_partial_price",
      text: "Partial Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            {row?.is_partial === "true"
              ? `₹${convertThenFormat(row?.total_partial_price || 0)}`
              : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "total_online",
      text: "Online Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            ₹
            {convertThenFormat(
              row?.is_partial === "true"
                ? row?.partial_total_online
                : row?.total_online || 0
            )}
          </p>
        </div>
      ),
    },
    {
      dataField: "total_cash",
      text: "Cash Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            ₹
            {convertThenFormat(
              row?.is_partial === "true"
                ? row?.partial_total_cash
                : row?.total_cash || 0
            )}
          </p>
        </div>
      ),
    },
    // {
    //   dataField: "plan_name",
    //   text: "Plan Name",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p
    //         className="info violetBg minWidth150"
    //         style={{
    //           background: "#E8E8FF",
    //           color: "#1E1E1E",
    //           borderRadius: "8px",
    //           padding: "5px 10px",
    //         }}
    //       >
    //         {row?.plan_name || "N/A"}
    //       </p>
    //     </div>
    //   ),
    // },
    // {
    //   dataField: "price",
    //   text: "Price",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info">₹{row?.price || "0"}</p>
    //     </div>
    //   ),
    // },
    {
      dataField: "start_date",
      text: "Start Date",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth90">
            {row?.start_date ? formatDateTimezon(row.start_date) : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "expire_date",
      text: "Expire Date",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth90">
            {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
          </p>
        </div>
      ),
    },
    // {
    //   dataField: "age",
    //   text: "Age",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info ">{row?.age || "N/A"}</p>
    //     </div>
    //   ),
    // },
    // {
    //   dataField: "gender",
    //   text: "Gender",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info ">{row?.gender || "N/A"}</p>
    //     </div>
    //   ),
    // },
    {
      dataField: "regular_subscription_status",
      text: "Subscription status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background:
                row?.regular_subscription_status === "active"
                  ? "#B4E7B9"
                  : "#F6EFEF",
              color:
                row?.regular_subscription_status === "active"
                  ? "#0A701B"
                  : "#F13434",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.regular_subscription_status || "NA"}
          </p>
        </div>
      ),
    },
  ];

  const pmInfoColumns = [
    {
      dataField: "payment_created",
      text: "Payment Created",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.payment_created
              ? formatDateTimezon(row.payment_created)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "Schedule Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.date ? convertStraight(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.amount || 0) || 0}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background:
                row?.status === "pending"
                  ? "#FFEDC0"
                  : row?.status === "completed"
                  ? "#B4E7B9"
                  : "#F3DADA",
              color:
                row?.status === "pending"
                  ? "#171717"
                  : row?.status === "completed"
                  ? "#0A701B"
                  : "#D90000",
              borderRadius: "10px",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <div
        className="tabsPayoutsContainer allPtMemTabs"
        style={{ padding: "0", width: "100%" }}
      >
        {/* <div className="allPtMembersTableContainer">
        <PaginatedTable
          columnsValues={tbColumns}
          dataValues={allAssignedMembersData.allData}
          paginationData={allAssignedMembersData.pagination}
          isPage={allAssignedMembersData.pageNo}
          setIsPage={(value) =>
            setAllAssignedMembersData((prevData) => ({
              ...prevData,
              pageNo: value,
            }))
          }
        />
      </div> */}

        <>
          <Tabs
            id="uncontrolled-payouts-tab"
            className="mb-3"
            onSelect={(selectedKey) => {
              onClickTab(selectedKey);
            }}
          >
            <Tab key={"addon_pt"} eventKey={"addon_pt"} title={"PT"}>
              <div className="allPtMembersTableContainer">
                {loading ? (
                  <ReactVortoxSpinner />
                ) : (
                  <PaginatedTable
                    columnsValues={tbColumns}
                    dataValues={allAssignedMembersData.allData}
                    paginationData={allAssignedMembersData.pagination}
                    isPage={allAssignedMembersData.pageNo}
                    setIsPage={(value) =>
                      setAllAssignedMembersData((prevData) => ({
                        ...prevData,
                        pageNo: value,
                      }))
                    }
                  />
                )}
              </div>
            </Tab>
            {/* <Tab key={"addon"} eventKey={"addon"} title={"Addon"}>
            <div className="allPtMembersTableContainer">
              {loading ? (
                <ReactVortoxSpinner />
              ) : (
                <PaginatedTable
                  columnsValues={tbColumns}
                  dataValues={allAssignedMembersData.allData}
                  paginationData={allAssignedMembersData.pagination}
                  isPage={allAssignedMembersData.pageNo}
                  setIsPage={(value) =>
                    setAllAssignedMembersData((prevData) => ({
                      ...prevData,
                      pageNo: value,
                    }))
                  }
                />
              )}
            </div>
          </Tab> */}
            <Tab key={"regular"} eventKey={"regular"} title={"Regular"}>
              <div className="allPtMembersTableContainer">
                {loading ? (
                  <ReactVortoxSpinner />
                ) : (
                  <PaginatedTable
                    columnsValues={tbColumnsRegular}
                    dataValues={allAssignedMembersData.allData}
                    paginationData={allAssignedMembersData.pagination}
                    isPage={allAssignedMembersData.pageNo}
                    setIsPage={(value) =>
                      setAllAssignedMembersData((prevData) => ({
                        ...prevData,
                        pageNo: value,
                      }))
                    }
                  />
                )}
              </div>
            </Tab>
            {/* <Tab
            key={"goal-focused"}
            eventKey={"goal-focused"}
            title={"Goal Focused"}
          >
            <div className="allPtMembersTableContainer">
              {loading ? (
                <ReactVortoxSpinner />
              ) : (
                <PaginatedTable
                  columnsValues={tbColumns}
                  dataValues={allAssignedMembersData.allData}
                  paginationData={allAssignedMembersData.pagination}
                  isPage={allAssignedMembersData.pageNo}
                  setIsPage={(value) =>
                    setAllAssignedMembersData((prevData) => ({
                      ...prevData,
                      pageNo: value,
                    }))
                  }
                />
              )}
            </div>
          </Tab> */}
          </Tabs>
        </>
      </div>

      <Modal
        onRequestClose={closeModalValues}
        ariaHideApp={false}
        isOpen={modValues.isModOpen}
      >
        <div className={`${"createNewCTOModalContainer"}`}>
          <ModalHeadAndClose
            title={modValues.cardType?.replace(/_/g, " ")}
            onClose={closeModalValues}
          />

          {modValues.cardType === "partial_details" ? (
            <div className="fullWidthFlexCenter separatedTable">
              <PayoutsTable
                dataValues={modValues.partialDetails}
                columnsValues={pmInfoColumns}
              />
            </div>
          ) : null}
        </div>
      </Modal>
    </>
  );
};

export default AsssignedMembersTab;
